import { styled } from '../../../../../modules';

export const Container = styled.div`
    background-color: #ffffff;
    width: 100%;
    padding: 0;
    border: 1px solid #edf2f7;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px 16px;
    border-bottom: 1px solid #edf2f7;

    &:last-child {
        border-bottom: none;
    }
`;

export const Label = styled.span`
    font-size: 13px;
    font-weight: 500;
    color: #4a5568;
    flex: 1;
    padding-right: 8px;
`;

export const Value = styled.span<{ $color: string }>`
    font-size: 13px;
    font-weight: 700;
    color: ${({ $color }) => $color ?? '#0e3573'};
    text-align: right;
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: #e2e8f0;
    margin: 4px 0;
`;
